import Vue from 'vue';
import { isAuthorized } from '../../utils/role' 


const state = {
    sidebarShow: 'responsive',
    sidebarMinimize: false,
    sidebarData: {},
    sidebarOrdersData: {},
};

const actions = {
    async fetchSidebarData(ctx) {
        let entities;
        let entityOrders;
        try {
            const settings = JSON.parse(localStorage.getItem('settings'));
            // Get admins entities
            if (settings?.is_business_admin && settings?.entities?.length) {
                // Check clones
                const set = [];
                const orderSet = [];
                // Get all entity types and make sidebar link objects
                entities = await Promise.all(settings.entities.map(async entity => {
                    const response = await Vue.axios.get(`/entities/get/${entity}`);
                    if (!set.includes(response.data.entityType.id)) {
                        set.push(response.data.entityType.id);
                        return {
                            _name: 'CSidebarNavItem',
                            name: response.data.entityType.title,
                            to: '/entities/' + response.data.entityType.code,
                            icon: response.data.entityType.icon,
                            show: true && isAuthorized(['operator','other','admin','super_admin','concierge_nigth', 'business_admin']),
                        };
                    }
                    // If clone set null
                    return null;
                }));
                entityOrders = await Promise.all(settings.entities.map(async entity => {
                    const response = await Vue.axios.get(`/entities/get/${entity}`);
                    if (!orderSet.includes(response.data.entityType.id)) {
                        orderSet.push(response.data.entityType.id);
                        return {
                            name: response.data.entityType.title,
                            to: `/orders/orders-ed/${response.data.entityType.id}`,
                            show: true,
                        };
                    }
                    // If clone set null
                    return null;
                }));
                // Clear sidebar link objects out of nulls
                entities = entities.filter(entity => !!entity);
                entityOrders = entityOrders.filter(entity => !!entity);
            } else if (settings?.is_business_admin && !settings?.entities?.length) {
                entities = [];
                entityOrders = [];
            } else {
                const response = await Vue.axios.get('/entities-type/');
                if (isAuthorized(['operator','other','admin','super_admin','concierge_nigth', 'business_admin'])) {
                    entities = response.data.map(entity => ({
                        _name: 'CSidebarNavItem',
                        name: entity.title,
                        to: `/entities/${entity.code}`,
                        icon: entity.icon,
                        show: true && isAuthorized(['operator','other','admin','super_admin','concierge_nigth', 'business_admin']),
                    }));
                }
                entityOrders = response.data.map(entity => ({
                    name: entity.title,
                    to: `/orders/orders-ed/${entity.id}`,
                    show: true,
                }));
            }

        } catch (error) {
            console.log('Cannot load entity data.');
        } finally {
            ctx.commit('setSidebarData', entities);
            ctx.commit('setSidebarOrdersData', entityOrders);
        }
    },
}

const getters = {
    sidebarData(state) {
        return state.sidebarData;
    },
    sidebarOrdersData(state) {
        return state.sidebarOrdersData;
    }
};

const mutations = {
    toggleSidebarDesktop (state) {
        const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile (state) {
        const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set (state, [variable, value]) {
        state[variable] = value
    },
    setSidebarData(state, data) {
        state.sidebarData = data;
    },
    setSidebarOrdersData(state, data) {
        state.sidebarOrdersData = data;
    }
}

export default {
    state,
    actions,
    getters,
    mutations
};
